import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ShieldAlert } from "lucide-react";
import { Input } from "@/components/ui/input";
import { API, errText } from "@/lib/auth";
import { SidePicker } from "./PaperBetForm";

export const OwnerRealBet = ({ m }) => {
  const [side, setSide] = useState("yes");
  const [amt, setAmt] = useState("5");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const place = async () => {
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/predict/real/order`, { slug: m.slug, side, amount: Number(amt), confirm });
      if (data.contracts > 0) toast.success(`REAL order filled: ${data.contracts} × ${data.side_name} (≈$${data.cost.toFixed(2)})`);
      else toast.warning("Order not filled (no matching price). Nothing was spent.");
      setConfirm("");
    } catch (e) { toast.error(errText(e)); } finally { setBusy(false); }
  };
  return (
    <div className="rounded-2xl border border-amber-500/40 bg-amber-500/5 p-4 space-y-3" data-testid="owner-real-bet">
      <div className="flex items-center gap-2 text-amber-200 font-semibold text-sm"><ShieldAlert className="w-4 h-4" />Owner only · REAL money on Polymarket US</div>
      <SidePicker m={m} side={side} setSide={setSide} prefix="real" />
      <div className="grid grid-cols-2 gap-2">
        <Input type="number" value={amt} onChange={(e) => setAmt(e.target.value)} placeholder="$ amount" className="h-11 bg-[var(--bg)] border-[var(--line)] font-num" data-testid="real-amount-input" />
        <Input value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder='Type "I UNDERSTAND"' className="h-11 bg-[var(--bg)] border-[var(--line)]" data-testid="real-confirm-input" />
      </div>
      <button onClick={place} disabled={busy || confirm.trim().toUpperCase() !== "I UNDERSTAND"} className="btn-primary w-full !bg-amber-400" data-testid="real-bet-btn">
        {busy ? "Sending order…" : `Place real $${amt || 0} order`}</button>
      <p className="text-[11px] text-slate-400">Immediate-or-cancel at the best live price. Capped by your max bet and daily trade limit from Live trading settings. Sell from the Polymarket app.</p>
    </div>
  );
};
